var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDigitalMarketing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_4857_1692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.2851 0.378413C53.1152 0.288413 51.9351 0.248413 50.7451 0.248413C23.1351 0.248413 0.745148 22.6384 0.745148 50.2484C0.745148 77.8584 23.1351 100.248 50.7451 100.248C72.3051 100.248 90.6751 86.5984 97.6951 67.4784C99.6651 62.1084 100.745 56.2984 100.745 50.2484C100.745 23.8284 80.2451 2.18841 54.2851 0.378413ZM90.8151 68.4284C83.8751 83.6484 68.5251 94.2484 50.7451 94.2484C26.4851 94.2484 6.74515 74.5084 6.74515 50.2484C6.74515 42.7784 8.61515 35.7484 11.9151 29.5784C19.3251 15.7084 33.9551 6.24841 50.7451 6.24841C75.0051 6.24841 94.7451 25.9884 94.7451 50.2484C94.7451 56.7284 93.3351 62.8884 90.8151 68.4284Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0251 71.5284C67.5851 71.0884 66.8752 71.0884 66.4352 71.5284L64.7251 69.8184C66.3251 67.6684 67.1852 65.0784 67.1852 62.3584C67.1852 59.0084 65.8851 55.8584 63.5151 53.4884C58.6251 48.5984 50.6751 48.5984 45.7851 53.4884C40.8951 58.3784 40.8951 66.3284 45.7851 71.2184C48.1551 73.5884 51.3051 74.8884 54.6551 74.8884C57.3751 74.8884 59.9751 74.0284 62.1151 72.4284L63.8251 74.1384C63.3852 74.5784 63.3852 75.2884 63.8251 75.7284L71.4951 83.3984C72.6552 84.5584 74.5451 84.5584 75.7051 83.3984C76.8652 82.2384 76.8652 80.3484 75.7051 79.1884L68.0351 71.5184L68.0251 71.5284ZM61.1551 68.8784C59.4151 70.6184 57.0951 71.5784 54.6351 71.5784C52.1751 71.5784 49.8551 70.6184 48.1151 68.8784C44.5251 65.2884 44.5251 59.4384 48.1151 55.8484C49.9151 54.0484 52.2751 53.1484 54.6351 53.1484C56.9951 53.1484 59.3551 54.0484 61.1551 55.8484C62.8951 57.5884 63.8551 59.9084 63.8551 62.3684C63.8551 64.8284 62.8951 67.1484 61.1551 68.8884V68.8784Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6451 55.2584C50.7252 55.2584 47.5451 58.4484 47.5451 62.3584C47.5451 63.0884 48.1451 63.6884 48.8751 63.6884C49.6051 63.6884 50.2051 63.0884 50.2051 62.3584C50.2051 59.9084 52.1951 57.9084 54.6551 57.9084C55.3851 57.9084 55.9851 57.3084 55.9851 56.5784C55.9851 55.8484 55.3851 55.2484 54.6551 55.2484L54.6451 55.2584Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0251 21.8084L64.7351 36.1584C64.1551 37.1584 64.8752 38.4184 66.0452 38.4184H69.7851V69.7584L77.4551 77.4384C77.9051 77.8884 78.2551 78.3884 78.5151 78.9284H78.8951V38.4184H82.6251C83.7851 38.4184 84.5152 37.1584 83.9352 36.1584L75.6451 21.8084C75.0651 20.8084 73.6152 20.8084 73.0351 21.8084H73.0251Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0351 47.7684C51.3451 46.9184 51.5752 46.0284 51.6952 45.1084H59.2551C59.1751 46.0684 59.0251 46.9984 58.8151 47.9184C59.9151 48.2284 60.9752 48.6684 61.9852 49.2384C62.3352 47.9084 62.5552 46.5184 62.6552 45.1084H64.2051C65.1451 45.1084 65.9052 44.3484 65.9052 43.4084C65.9052 42.4684 65.1451 41.7084 64.2051 41.7084H62.6552C61.8251 30.0484 52.5051 20.6984 40.8551 19.8384V18.3584C40.8551 17.4184 40.0951 16.6584 39.1551 16.6584C38.2151 16.6584 37.4551 17.4184 37.4551 18.3584V19.8384C25.7351 20.6284 16.3351 30.0084 15.4951 41.7184H14.0251C13.0851 41.7184 12.3251 42.4784 12.3251 43.4184C12.3251 44.3584 13.0851 45.1184 14.0251 45.1184H15.4951C16.3351 56.8084 25.6951 66.1684 37.3751 66.9984V68.4684C37.3751 69.4084 38.1352 70.1684 39.0751 70.1684C40.0151 70.1684 40.7751 69.4084 40.7751 68.4684V68.1984C40.0051 66.3784 39.6051 64.4084 39.6051 62.3684C39.6051 60.3284 40.0051 58.3584 40.7751 56.5384V56.0284C40.8551 56.0184 40.9351 56.0084 41.0151 55.9884C41.7451 54.4284 42.7451 52.9984 44.0051 51.7384C46.0151 49.7284 48.4551 48.4084 51.0351 47.7784V47.7684ZM40.8551 23.2484C50.6351 24.0984 58.4352 31.9284 59.2551 41.7184H51.6952C50.9352 36.0784 46.4851 31.6084 40.8551 30.8184V23.2484ZM48.2652 41.7184H43.3551C42.8951 40.5684 41.9951 39.6484 40.8551 39.1684V34.2384C44.6151 34.9684 47.5752 37.9484 48.2652 41.7184ZM34.8151 41.7184H29.8951C30.6051 37.8984 33.6351 34.8884 37.4651 34.2184V39.1184C36.2551 39.5784 35.2951 40.5184 34.8151 41.7184ZM37.4651 23.2384V30.7984C31.7651 31.5184 27.2351 36.0284 26.4751 41.7184H18.9151C19.7351 31.8784 27.6151 24.0284 37.4651 23.2384ZM37.3851 63.5784C27.5751 62.7584 19.7351 54.9284 18.9151 45.1084H26.4751C27.2351 50.7684 31.7251 55.2584 37.3851 56.0184V63.5784ZM29.8951 45.1084H34.8151C35.2851 46.2784 36.2151 47.2184 37.3851 47.6784V52.5984C33.5951 51.8984 30.5951 48.9084 29.8951 45.1084ZM40.7751 52.5984V47.6884C41.9551 47.2184 42.8851 46.2884 43.3551 45.1084H48.2652C47.5652 48.9084 44.5751 51.8984 40.7751 52.5984Z",
    fill: "#9933CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_4857_1692",
    x: 0.0000118613,
    y: 0.0000344813,
    width: 101.49,
    height: 102.32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.496757
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.372568
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "screen",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4857_1692"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4857_1692",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.07148
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.86284
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect2_innerShadow_4857_1692"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.24189
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "soft-light",
    in2: "effect2_innerShadow_4857_1692",
    result: "effect3_innerShadow_4857_1692"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalMarketing);
export default __webpack_public_path__ + "static/media/DigitalMarketing.a29e50cd8fd121dcac8f9c4d4201e080.svg";
export { ForwardRef as ReactComponent };